import script from "./VerificationCode.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationCode.vue?vue&type=script&setup=true&lang=js"

import "./VerificationCode.vue?vue&type=style&index=0&id=1dee4948&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dee4948"]])

export default __exports__